// // src/api/authApi.js
// import axios from "axios";

// // Normalize base URL (works with or without trailing slash)
// const BASE = process.env.REACT_APP_API_BASE_URL
//   .replace(/\/+$/, "");

// // Shared axios instance
// export const api = axios.create({ baseURL: BASE });

// // Attach JWT on every request (if present)
// api.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token");
//   if (token) config.headers.Authorization = `Bearer ${token}`;
//   return config;
// });

// // Global auth/demo handling
// api.interceptors.response.use(
//   (res) => res,
//   (err) => {
//     const { status, data } = err.response || {};
//     if (status === 401) {
//       // token expired/invalid → logout
//       localStorage.removeItem("token");
//       localStorage.removeItem("isDemo");
//       localStorage.removeItem("authToken");
//       // redirect to login page
//       if (typeof window !== "undefined") window.location.href = "/login";
//     } else if (status === 403 && data?.error === "DEMO_READ_ONLY") {
//       // Optional UX: let user know writes are blocked in demo
//       // Replace alert with your toast system if you have one
//       // eslint-disable-next-line no-alert
//       alert("Demo mode: create/update/delete actions are disabled.");
//     }
//     return Promise.reject(err);
//   }
// );

// // === Auth APIs ===
// export const loginUser = async (email, password) => {
//   const { data } = await api.post("/api/auth/login", { email, password });
//   // Keep storage logic in your Signin component (as you already do)
//   return data; // { token, ... }
// };

// export const registerUser = async (email, password) => {
//   const { data } = await api.post("/api/auth/register", { email, password });
//   return data;
// };

// // NEW: Demo token for read-only preview
// export const getDemoToken = async () => {
//   const { data } = await api.post("/api/auth/demo-token");
//   // You can store here or do it in the caller.
// //   localStorage.setItem("token", data.token);
// //   localStorage.setItem("isDemo", "1");
//   return data; // { token }
// };

// // (Optional) helpers
// export const logout = () => {
//   localStorage.removeItem("token");
//   localStorage.removeItem("isDemo");
//   localStorage.removeItem("authToken");
// };
// src/api/authApi.js
import axios from "axios";

// Normalize base URL (works with or without trailing slash)
const BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");

// Single source of truth for keys (optional, but keep if you use them elsewhere)
export const TOKEN_KEY = "token";
export const DEMO_KEY = "isDemo";

// Redirect path for POS signin
export const POS_SIGNIN_PATH = "/pos/signin";

// Shared axios instance
export const api = axios.create({ baseURL: BASE });

// Attach JWT on every request (if present)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Global auth/demo handling
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const { status, data } = err.response || {};

    if (status === 401) {
      // Clear ALL localStorage keys
      localStorage.clear();

      // redirect to POS signin
      if (typeof window !== "undefined") {
        window.location.assign(POS_SIGNIN_PATH);
      }
    } else if (status === 403 && data?.error === "DEMO_READ_ONLY") {
      // Optional UX for demo write attempts
      // eslint-disable-next-line no-alert
      alert("Demo mode: create/update/delete actions are disabled.");
    }

    return Promise.reject(err);
  }
);

// === Auth APIs ===
export const loginUser = async (email, password) => {
  const { data } = await api.post("/api/auth/login", { email, password });
  return data; // { token, ... }
};

export const registerUser = async (email, password) => {
  const { data } = await api.post("/api/auth/register", { email, password });
  return data;
};

export const getDemoToken = async () => {
  const { data } = await api.post("/api/auth/demo-token");
  return data; // { token }
};

// Helpers
export const logout = () => {
  // Clear ALL localStorage keys
  localStorage.clear();

  // If you want logout() itself to also redirect (optional), uncomment:
  // if (typeof window !== "undefined") window.location.assign(POS_SIGNIN_PATH);
};
